module.exports = __webpack_public_path__ + "index.html";


//////////////////
// WEBPACK FOOTER
// ./index.src.html
// module id = 28
// module chunks = 0